import { createReducer, on } from '@ngrx/store';

import { BaseActionState } from '@ptg-shared/types/models';
import { ActuaryReportAction } from '../actions';

export const ActuaryReportFeatureKey = 'actuaryReport';
export interface ActuaryReportState {
  exportActuaryReportState?: BaseActionState;
}

const initialState: ActuaryReportState = {
};

export const actuaryReportReducer = createReducer(
  initialState,
  on(ActuaryReportAction.setExportActuaryReportStateAction, (state) => ({
      ...state,
      exportActuaryReportState: {
        isLoading: true,
      },
    })),
    on(ActuaryReportAction.setExportActuaryReportStateSuccessAction, (state) => ({
      ...state,
      exportActuaryReportState: {
        isLoading: false,
        success: true,
      },
    })),
    on(ActuaryReportAction.setExportActuaryReportStateFailureAction, (state) => ({
      ...state,
      exportActuaryReportState: {
        isLoading: false,
        success: false,
      },
    })),
    on(ActuaryReportAction.clearSetExportActuaryReportStateAction, (state) => ({
      ...state,
      exportActuaryReportState: undefined
    })),
);
